window.addEventListener("load", function() {
    document.body.addEventListener('click', function(event) {
        if (event.target && event.target.classList.contains('btn')) {
            const btn = event.target;
            const recommended_product = btn.closest(".cart_recommendation_product__form");
            if (recommended_product) {
                sendRecommendedProductForm(btn);
            }
        }
    });
});

async function sendRecommendedProductForm(btn) {
    document.dispatchEvent(
        new CustomEvent("theme:cart:add", {
            detail: {
                button: btn,
            },
        }),
    )
}